export default __webpack_public_path__ + "static/french-e6dbc48d20b91c5c6e24873246464d7e.jpg";